import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  BannerOverlay,
  BannerText,
  BannerTitle,
  BannerButtons,
  OutlineButton,
  AcceptButton,
} from "./styles";

const COOKIE_KEY = "qt_cookie_consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = sessionStorage.getItem(COOKIE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  const handleDoNotSell = () => {
    sessionStorage.setItem(COOKIE_KEY, "do-not-sell");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <BannerOverlay>
      <BannerText>
        <BannerTitle>
          <span>Control your privacy</span>
        </BannerTitle>
        <p>
          Our website uses cookies to improve navigation.{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>
        </p>
      </BannerText>
      <BannerButtons>
        <OutlineButton onClick={handleDoNotSell}>Do not sell</OutlineButton>
        <AcceptButton onClick={handleAccept}>Accept</AcceptButton>
      </BannerButtons>
    </BannerOverlay>
  );
};

export default CookieBanner;
